export const IMAGES = {
  hero: "/assets/hero-plotter-dark.png",
  plotter_ui: "/assets/plotter-ui.png",
  shapelib_bg: "/assets/shapeeditor-ui.png",
};

export const GCODE_SNIPPET = `; CNCROUTERSOFT EXPORT
G21            ; metric units
G90            ; absolute positioning
M3 S12000      ; spindle on
G0 Z5.000
G0 X0.000 Y0.000
G1 Z-1.500 F300
G1 X48.000 Y0.000 F900
G1 X48.000 Y36.000
G1 X0.000 Y36.000
G1 X0.000 Y0.000
G0 Z5.000
M5             ; spindle off
M30            ; end program`;
